/**
 * Panelin üst bandında çizilecek lisans uyarısı.
 *
 * Bant dört durumda görünür ve sırası önemlidir: kısıt etkinken diğer
 * uyarıların hepsi anlamsızdır, bitiş uyarısı ise lisans hâlâ "aktif"ken
 * çizilir — yenileme penceresi kaçarsa kurulum bir sabah kısıtlı uyanır.
 *
 * Durum ``/admin/license/banner`` ucundan gelir; kısıtın ne kapattığı tek
 * yerde yazılıdır (bkz. backend/services/license.py ``ACTION_MESSAGES``).
 */

const RESTRICTED_BODY = 'Oyuncu portalı tümüyle kapalı: ziyaretçiler '
  + '"erişilemiyor" duyurusunu görüyor. Yalnızca yönetim paneli açık.';

const formatDay = (value) => (value
  ? new Date(value).toLocaleDateString('tr-TR', {
    day: '2-digit', month: 'long', year: 'numeric',
  })
  : '');

export const buildLicenseNotice = (banner) => {
  if (!banner) return null;

  if (banner.restricted) {
    // Sebebi söylemek gerekir: anahtarsız kurulumda çözüm "bekle" değil,
    // "lisansı tanımla"dır.
    return {
      blocked: true,
      title: banner.configured
        ? 'Lisans kısıtı etkin'
        : 'Lisans tanımlı değil — kısıt etkin',
      body: banner.configured
        ? RESTRICTED_BODY
        : `${RESTRICTED_BODY} Lisans sayfasından anahtarı tanımlayın.`,
    };
  }

  // Kısıtsız ama anahtarsız kurulum muaftır (``LICENSE_REQUIRED=0``) ve bu
  // bilinçli bir karardır: bant çizilmez, muafiyet panelde duyurulmaz.
  if (!banner.configured) return null;

  if (banner.expiring_soon) {
    const days = Number(banner.days_left);
    const when = formatDay(banner.expires_at);
    return {
      blocked: false,
      title: days <= 0
        ? 'Lisans bugün doluyor'
        : `Lisansın bitişine ${days} gün kaldı`,
      body: `Lisans ${when} tarihinde doluyor. Yenilenmezse oyuncu portalı `
        + 'tümüyle kapanır.',
    };
  }

  if (banner.status !== 'active') {
    return {
      blocked: false,
      title: `Lisans durumu: ${banner.status_label || banner.status}`,
      body: banner.message || '',
    };
  }

  return null;
};

export default buildLicenseNotice;
